// Build-time deployment provenance; NODE_ENV alone also describes Preview builds.
function resolveAnalyticsDeployment(env) {
  const target = env.ANALYTICS_BUILD_TARGET;
  if (target && !['production', 'preview', 'local'].includes(target)) throw new Error('Unknown analytics build target.');
  const branchTarget = env.CF_PAGES_BRANCH ? (env.CF_PAGES_BRANCH === 'main' ? 'production' : 'preview') : null;
  const vercelTarget = env.VERCEL_ENV ? (env.VERCEL_ENV === 'production' ? 'production' : 'preview') : null;
  if (branchTarget && vercelTarget && branchTarget !== vercelTarget) throw new Error('Conflicting deployment provenance.');
  const observed = branchTarget || vercelTarget;
  if (target === 'production' && observed !== 'production') throw new Error('Production requires main/production provenance before next build.');
  if (target === 'preview' && observed === 'production') throw new Error('Preview target conflicts with production provenance.');
  if (target === 'local' && observed) throw new Error('Local target conflicts with deployment provenance.');
  return target === 'local' ? 'disabled' : (target || observed || 'disabled');
}
module.exports = { resolveAnalyticsDeployment };
